// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__L-hyu","cabecalho__container":"Cabecalho_cabecalho__container__Sc0E5","cabecalho__input":"Cabecalho_cabecalho__input__u0zDc"};